import { IExtensionsServerSettings } from '../types/IEditableServerSettings';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetExtensionsServerSettingsParams {
}

export type IGetExtensionsServerSettingsResult = IResult & IExtensionsServerSettings;

export class GetExtensionsServerSettingsRequest extends Request<IGetExtensionsServerSettingsParams, IGetExtensionsServerSettingsResult> {
  constructor(params: IGetExtensionsServerSettingsParams) {
    super('getExtensionsServerSettings', params);
  }
}
